import { useEffect, useState } from "react"
import { fetchMaintenanceStatus } from "@/lib/api"

interface Props {
  onResolved: () => void
  onLogout: () => void
}

export function MaintenancePage({ onResolved, onLogout }: Props) {
  const [checking, setChecking] = useState(false)
  const [lastChecked, setLastChecked] = useState<string | null>(null)

  const check = async () => {
    setChecking(true)
    const enabled = await fetchMaintenanceStatus()
    setLastChecked(new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }))
    setChecking(false)
    if (!enabled) onResolved()
  }

  useEffect(() => {
    const id = setInterval(check, 30_000)
    return () => clearInterval(id)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="min-h-svh flex flex-col items-center justify-center gap-6 px-4 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-500/10">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 text-amber-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l5.654-4.654m5.71-2.204 2.163-2.163a1.414 1.414 0 0 0 0-2l-1.427-1.428a1.414 1.414 0 0 0-2 0L9.128 6.29m5.71-2.204L9.128 6.29m0 0L3 12.418" />
        </svg>
      </div>
      <div className="max-w-md">
        <h1 className="text-2xl font-semibold tracking-tight">Under Maintenance</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          The system is currently undergoing maintenance. Please check back in a few minutes.
        </p>
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={check}
          disabled={checking}
          className="px-4 py-2 rounded-lg bg-foreground text-background text-sm font-medium hover:bg-foreground/90 disabled:opacity-60 transition-colors"
        >
          {checking ? "Checking…" : "Check now"}
        </button>
        <button
          onClick={onLogout}
          className="px-4 py-2 rounded-lg border text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-secondary/50 transition-colors"
        >
          Back to login
        </button>
      </div>
      <p className="text-xs text-muted-foreground/60">
        This page refreshes automatically when service is restored.
        {lastChecked && <> Last checked at {lastChecked}.</>}
      </p>
    </div>
  )
}
